// extracted by mini-css-extract-plugin
export default {"words":"words-area_words__ulFnS","word":"words-area_word__wEJkm","selected":"words-area_selected__wI3MU"};